import React, { useEffect, useState } from 'react'
import emailjs from 'emailjs-com'
import AOS from 'aos'
import 'aos/dist/aos.css'

const Contact = () => {

    useEffect(() => {
        AOS.init()
    }, [])

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")

    const onNameChange = (event) => {
        setName(event.target.value)
    }

    const onEmailChange = (event) => {
        setEmail(event.target.value)
    }

    const onMessageChange = (event) => {
        setMessage(event.target.value)
    }

    const submitMessage = (e) => {
        const button = document.querySelector('#form-button')
        e.preventDefault()

        button.innerHTML = 'Finding Agni...'
        button.style.animation = 'bounce 0.75s alternate ease-in-out infinite'
        let toSend = {
            from_name: name,
            to_name: "Agni Saha",
            from_email: email,
            message: message
        }
        emailjs.send('service_3i41o2m', 'template_octwfak', toSend, 'user_HtQGhYQZ4jSxC629HapsD')
            .then(res => {
                button.style.backgroundColor = 'lightseagreen'
                button.style.animation = ''
                button.innerHTML = 'Message Sent!'

                Array.from(document.querySelectorAll('input')).map(el => el.value = '')
                document.querySelector('textarea').value = ''

                setTimeout(() => {
                    button.style.backgroundColor = 'lightsalmon'
                    button.innerHTML = 'Send'
                }, 3200)
            })
    }

    return (
        <>
            <div className="contacts-header"
                data-aos="fade-up"
                data-aos-offset="250"
                data-aos-delay="100"
                data-aos-duration="800"
                data-aos-easing="ease">
                <small>(003)</small> Enough About Me.
                <br /> Let's Talk About You.
            </div>

            <div className="contacts"
                data-aos="fade-up"
                data-aos-offset="250"
                data-aos-delay="100"
                data-aos-duration="800"
                data-aos-easing="ease"
            >
                CONTACT ME
            </div>

            <form>
                <div data-aos="fade-in"
                    data-aos-offset="200"
                    data-aos-delay='400'
                    data-aos-duration="1000" data-aos-easing="ease">
                    <p>
                        So, who's talking? <br />
                        <input name='personName' autoComplete='off'
                            placeholder="Your Name" type="text" required
                            value={name} onChange={onNameChange}
                        />
                    </p>

                    <p>
                        And your Email?
                        <input name='from_email' autoComplete='off'
                            placeholder="Your email" aria-describedby="emailInput"
                            type="email" required
                            value={email} onChange={onEmailChange}
                        />
                    </p>

                    <p>
                        And your message...
                        <textarea name='personMessage' autoComplete='off'
                            placeholder="Message" rows="5" type="text" required
                            value={message} onChange={onMessageChange}
                        />
                    </p>
                </div>

                <section>
                    <button id='form-button'
                        onClick={submitMessage}
                    >
                        Send
                    </button>
                    <div id='socials'>
                        <h1> STALK ME </h1>
                        <div>
                            <a href="https://www.linkedin.com/in/agnisaha337599/"
                                target="_blank" rel="noreferrer"
                            >
                                LINKEDIN
                            </a>
                            <a href="https://github.com/Agni-Saha"
                                target="_blank" rel="noreferrer"
                            >
                                GITHUB
                            </a>
                            <a href="https://www.instagram.com/joe.the.average/"
                                target="_blank" rel="noreferrer"
                            >
                                INSTAGRAM
                            </a>
                        </div>

                    </div>
                </section>

            </form>
        </>
    )
}

export default Contact